import React from 'react'
const DashboardInfoSkeleton = ({rows}) => {
    return (
        <>
            <style>
                {
                    `
                        .skeleton {
                            animation: pulse 1.5s infinite ease-in-out !important;
                            background: #d5d6d8ff !important;
                            border-radius: 3px !important;
                        }
                        @keyframes pulse {
                            0%, 100% {
                                opacity: 1;
                            }
                            50% {
                                opacity: 0.4;
                            }
                        }
                    `
                }
            </style>
            {[...Array(rows)].map((_, index) => (
                <div className="col-md-12 mb-6" key={index}>
                    <div className="card">
                        <div className="card-body pb-0 ribbon ribbon-end ribbon-clip">
                            <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                                <div className="flex-grow-1">
                                    <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                        <div className="d-flex flex-column">
                                            <div className="d-flex align-items-center mb-2">
                                                <div className="text-gray-900 fs-2 fw-bold me-1 d-flex">
                                                    <div className='skeleton me-3' style={{height:'20px', width:'200px'}}></div>
                                                    <div className='skeleton' style={{height:'20px', width:'80px'}}></div>
                                                </div>
                                            </div>
                                            <div className="d-flex flex-wrap fw-semibold fs-6 pe-2 mb-2">
                                                <div className='skeleton me-2' style={{height:'15px', width:'100px'}}></div>
                                                <div className='skeleton me-2' style={{height:'15px', width:'200px'}}></div>
                                                <div className='skeleton' style={{height:'15px', width:'100px'}}></div>
                                            </div>
                                        </div>
                                        <div className="d-flex my-4">
                                            <div className='skeleton me-2' style={{height:'35px', width:'110px'}}></div>
                                            <div className='skeleton' style={{height:'35px', width:'35px'}}></div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap flex-stack">
                                        <div className="d-flex flex-column flex-grow-1 pe-8">
                                            <div className="d-flex flex-wrap">
                                                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="fs-4 fw-bold text-gray-700">
                                                            <div className='skeleton' style={{height:'18px', width:'100px'}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="fw-semibold fs-6 text-gray-600">
                                                        <div className='skeleton' style={{height:'15px', width:'80px'}}></div>
                                                    </div>
                                                </div>
                                                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="fs-4 fw-bold text-gray-700">
                                                            <div className='skeleton' style={{height:'18px', width:'100px'}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="fw-semibold fs-6 text-gray-600">
                                                        <div className='skeleton' style={{height:'15px', width:'80px'}}></div>
                                                    </div>
                                                </div>
                                                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="fs-4 fw-bold text-gray-700">
                                                            <div className='skeleton' style={{height:'18px', width:'150px'}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="fw-semibold fs-6 text-gray-600">
                                                        <div className='skeleton' style={{height:'15px', width:'80px'}}></div>
                                                    </div>
                                                </div>
                                                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="fs-4 fw-bold text-gray-700">
                                                            <div className='skeleton' style={{height:'18px', width:'120px'}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="fw-semibold fs-6 text-gray-600">
                                                        <div className='skeleton' style={{height:'15px', width:'80px'}}></div>
                                                    </div>
                                                </div>
                                                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="fs-4 fw-bold text-gray-700">
                                                            <div className='skeleton' style={{height:'18px', width:'120px'}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="fw-semibold fs-6 text-gray-600">
                                                        <div className='skeleton' style={{height:'15px', width:'80px'}}></div>
                                                    </div>
                                                </div>
                                                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="fs-4 fw-bold text-gray-700">
                                                            <div className='skeleton' style={{height:'18px', width:'180px'}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="fw-semibold fs-6 text-gray-600">
                                                        <div className='skeleton' style={{height:'15px', width:'80px'}}></div>
                                                    </div>
                                                </div>
                                                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <div className="fs-4 fw-bold text-gray-700">
                                                            <div className='skeleton' style={{height:'18px', width:'150px'}}></div>
                                                        </div>
                                                    </div>
                                                    <div className="fw-semibold fs-6 text-gray-600">
                                                        <div className='skeleton' style={{height:'15px', width:'80px'}}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}
export default DashboardInfoSkeleton